<template>
  <transition name="slideup" mode="out-in">
    <div
      v-if="isOpen"
      class="fixed z-99 flex justify-center items-center inset-0 h-screen p-8"
    >
      <div class="fixed inset-0 w-full h-screen opacity-75 bg-dark"></div>
      <!-- backdrop -->
      <div :class="wrapperClass" :style="{ width }">
        <span
          class="absolute top-4 right-4 cursor-pointer text-grey-500"
          @click="close()"
          ><close-icon class="h-5 w-5 cursor-pointer"></close-icon
        ></span>
        <span :style="bgColor" :class="iconClass">
          <component :is="icon" class="w-5 h-5 fill-current"></component>
        </span>
        <h2 class="font-bold text-lg mb-4 text-center">
          <slot name="title">A title for the alert</slot>
        </h2>
        <slot></slot>
        <div class="flex items-center gap-4"><slot name="actions"></slot></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { twJoin } from 'tailwind-merge';
import CheckIcon from '../assets/check-icon.svg';
import CloseIcon from '../assets/close-icon-new.svg';
import HelpIcon from '../assets/icons/question.svg';

export default {
  name: 'PopupAlert',
  props: {
    variant: { type: String, default: 'info' }, // info, success, error
    width: { type: String, default: '600px' },
    allowOverflow: { type: Boolean, default: false }
  },
  components: { CloseIcon, CheckIcon, HelpIcon },
  data() {
    return { isOpen: true };
  },
  computed: {
    wrapperClass() {
      const baseClass =
        'rounded-lg bg-white shadow-2xl relative flex flex-col justify-center items-center text-center py-10 px-6';
      const overflowClass = this.allowOverflow ? '' : 'overflow-hidden';
      return twJoin(baseClass, overflowClass);
    },
    iconClass() {
      const baseClass =
        'inline-flex justify-center items-center w-10 h-10 rounded-md border mb-6';
      const variantClass = {
        info: 'text-blue border-blue',
        success: 'text-success border-success',
        error: 'text-danger border-danger'
      };
      return twJoin(baseClass, variantClass[this.variant]);
    },
    icon() {
      const variantIcon = {
        info: HelpIcon,
        success: CheckIcon,
        error: CloseIcon
      };
      return variantIcon[this.variant];
    },
    bgColor() {
      switch (this.variant) {
        case 'info':
          return `background-color: color-mix(in srgb, rgb(48, 139, 229) 20%, white)`;
        case 'success':
          return `background-color: color-mix(in srgb, var(--brand-success) 20%, white)`;
        case 'error':
          return `background-color: color-mix(in srgb, var(--brand-danger) 20%, white)`;
      }
    }
  },
  methods: {
    close() {
      this.isOpen = false;
      this.$emit('close');
    }
  }
};
</script>
